/**
 * @Author: tom
 * @Date:   2017-11-20T00:11:45+01:00
 * @Last modified by:   tom
 * @Last modified time: 2018-10-26T17:52:41+02:00

The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias.

**/

import Vue from 'vue'
import App from './App'
import router from './router'
// Language and locales
import i18n from '@/assets/lang/_locales'
// Templating
import BootstrapVue from 'bootstrap-vue'
// project defined icons
import '@/lib/modules/_icons'
// iframe embed
import '@/lib/modules/_page_embed.js'
import '@/lib/modules/_page_embed.scss'
// lazy image handler
import '@/lib/modules/_lazy-image.js'

// Analytics
import VueAnalytics from 'vue-analytics'

// filters & mixins
import Filters from '@/lib/filters'
import Mixins from '@/lib/mixins'

/** RESOURCES for POST/GET */
import VueResource from 'vue-resource'

import './registerServiceWorker'
Vue.use(VueResource)

Vue.use(Filters)
Vue.use(Mixins)
Vue.use(BootstrapVue)
Vue.config.productionTip = false

// https://github.com/MatteoGabriele/vue-analytics
Vue.use(VueAnalytics, {
  id: 'UA-3065002-1', // www.lorinthe.com Google Analytics code; different code needed for other sites
  router: router
  // debug: {
  //   enabled: true,
  //   trace: false,
  //   sendHitTask: true
  // }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})

// Listen for claiming of our ServiceWorker
// And then reload automatically
navigator.serviceWorker.addEventListener('controllerchange', function () {
  console.log('Service worker status changed: ', this.controller.state)
  // Listen for changes in the state of our ServiceWorker
  navigator.serviceWorker.controller.addEventListener('statechange', function () {
    // If the ServiceWorker becomes "activated", let the user know they can go offline!
    if (this.state === 'activated') {
      window.location.reload(true)
    }
  })
})
